import { render, staticRenderFns } from "./video-content.vue?vue&type=template&id=2c2f17ee"
import script from "./video-content.vue?vue&type=script&lang=js"
export * from "./video-content.vue?vue&type=script&lang=js"
import style0 from "./video-content.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports